import { createSelector } from 'reselect';

import orm from '../../../app/orm';
import { getEntities } from './getEntities';

export const getEntitiesSession = createSelector(
  getEntities,
  entities => orm.session(entities)
);
